module.exports = __webpack_public_path__ + "img/益视说明书_12.a18e59f9.png";